import { getTheme, setTheme as persistTheme, type Theme } from '$lib/utils/theme';

let current = $state<Theme>('dark');

/** Shared reactive theme state. Use via Svelte context in the layout. */
export function useTheme() {
	return {
		get current() {
			return current;
		},
		init() {
			current = getTheme();
			persistTheme(current);
		},
		toggle() {
			current = current === 'dark' ? 'light' : 'dark';
			persistTheme(current);
			return current;
		},
		set(theme: Theme) {
			current = theme;
			persistTheme(theme);
		}
	};
}

export type ThemeStore = ReturnType<typeof useTheme>;
